
import { CategoryResponse } from 'services/interface'
import { getAllCategory, getCategory } from 'services/categoryApi'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const useGetCategory = (): UseQueryResult<CategoryResponse, Error> => {
  return useQuery<CategoryResponse, Error>({
    queryKey: ['category'],
    queryFn: () => getCategory(),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  })
}

export const useGetAllCategory = (): UseQueryResult<CategoryResponse, Error> => {
  return useQuery<CategoryResponse, Error>({
    queryKey: ['categoryAll'],
    queryFn: () => getAllCategory(),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  })
}
